export default __webpack_public_path__ + "static/preloader-logo-js-2-c6a132b3aa4c7edf9117a3a7c5af2e2d.svg";